import { createContext, useContext } from "react";

export const LANGS = [
  { code: "it", label: "IT" },
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

export const LangContext = createContext({ lang: "it", setLang: () => {}, t: {} });
export const useLang = () => useContext(LangContext);

export const WHATSAPP_URL = "https://wa.me/41764411359";
export const PHONE_DISPLAY = "+41 76 441 13 59";
export const EMAIL = "info@graficawebdesign.com";

export const DICT = {
  it: {
    nav: {
      how: "Come funziona", salons: "Parrucchieri", restaurants: "Ristoranti",
      included: "Cosa include", pricing: "Prezzo", demo: "Demo", why: "Chi siamo",
      contact: "Contatti", cta: "Parla su WhatsApp",
    },
    hero: {
      badge: "Agenzia AI vocale · Svizzera",
      lines: ["Il tuo telefono squilla.", "L'AI risponde.", "Tu guadagni."],
      sub: "Agenti AI vocali per parrucchieri e ristoranti. Prenotazioni automatiche, app e sito inclusi. 2 CHF al giorno.",
      cta1: "Prova l'AI", cta2: "Scrivici su WhatsApp", live: "AI IN LINEA",
      stats: [
        { value: 12480, suffix: "+", label: "Chiamate risposte" },
        { value: 8930, suffix: "+", label: "Prenotazioni gestite" },
        { value: 1, suffix: "s", label: "Tempo di risposta" },
        { value: 2, suffix: " CHF", label: "Al giorno, tutto incluso" },
      ],
    },
    marquee: ["ZERO CHIAMATE PERSE", "2 CHF AL GIORNO", "CALENDARIO SINCRONIZZATO", "ITALIANO · DEUTSCH · FRANÇAIS", "GUERRILLA CALLING OUTBOUND", "APP & SITO INCLUSI"],
    how: {
      kicker: "Come funziona",
      title: "Dallo squillo alla prenotazione in 60 secondi",
      sub: "Tre passi. Nessun software da installare. Nessuna formazione.",
      steps: [
        { t: "L'AI riceve la chiamata", d: "Risponde al primo squillo con voce naturale, in italiano, tedesco, francese o inglese." },
        { t: "Gestisce la prenotazione", d: "Propone gli slot liberi, risponde alle domande, gestisce modifiche e cancellazioni." },
        { t: "Conferma sul calendario", d: "L'appuntamento appare in agenda e il cliente riceve conferma via SMS o WhatsApp." },
      ],
      phone: { incoming: "Chiamata in arrivo…", ai: "GWD AI risponde…", done: "Prenotazione confermata", cal: "Aggiunta al calendario" },
    },
    salon: {
      kicker: "Per parrucchieri",
      title: "Le forbici in mano. Il telefono che squilla.",
      painLabel: "IL PROBLEMA",
      pain: "«Stai tagliando i capelli. Il telefono squilla. Non puoi rispondere. Il cliente prenota dal concorrente.»",
      solLabel: "LA SOLUZIONE",
      solTitle: "L'AI risponde per te. Sempre.",
      sol: "L'agente AI GWD risponde al primo squillo con una voce cordiale e naturale, propone gli slot liberi, prenota il trattamento e ti manda la notifica. Tu continui a tagliare.",
      bullets: ["Risponde in 1 secondo, anche mentre lavori", "Scrive l'appuntamento direttamente in agenda", "Zero chiamate perse, zero clienti regalati"],
      cta: "Attiva per il tuo salone",
    },
    restaurant: {
      kicker: "Per ristoranti",
      title: "Ora di punta. Nessuno può rispondere.",
      painLabel: "IL PROBLEMA",
      pain: "«Sala piena, cucina al massimo. Sette chiamate perse in un'ora. Sono tavoli — e incasso — regalati.»",
      solLabel: "LA SOLUZIONE",
      solTitle: "L'AI prenota i tavoli. 24/7.",
      sol: "L'AI risponde a più telefonate in simultanea, prenota i tavoli, gestisce modifiche e cancellazioni e risponde alle domande sul menu. Anche a mezzanotte.",
      bullets: ["Gestisce più chiamate contemporaneamente", "Prenotazioni, modifiche e cancellazioni automatiche", "Risponde a domande su menu e allergeni"],
      cta: "Attiva per il tuo ristorante",
    },
    included: {
      kicker: "Cosa è incluso",
      title: "Tutto. In un'unica piattaforma.",
      sub: "Nessun costo nascosto. Nessun fornitore extra.",
      items: [
        { name: "Agente AI telefonico", desc: "Risponde alle chiamate in entrata con voce naturale, prenota e informa.", badge: "Core" },
        { name: "Chiamate in uscita", desc: "Campagne outbound e guerrilla marketing telefonico per riattivare i clienti.", badge: "Growth" },
        { name: "App personalizzata", desc: "La tua app per iOS e Android con prenotazioni e notifiche.", badge: "iOS · Android" },
        { name: "Sito web incluso", desc: "Sito veloce e moderno, pensato per trasformare visitatori in prenotazioni.", badge: "Web" },
        { name: "Calendario & POS", desc: "Sincronizzazione con Google Calendar e i principali gestionali.", badge: "Sync 24/7" },
        { name: "Multilingua svizzero", desc: "Italiano, tedesco, francese e inglese. Come i tuoi clienti.", badge: "IT·DE·FR·EN" },
        { name: "Report & statistiche", desc: "Registrazioni, analisi delle chiamate e report mensili chiari.", badge: "Analytics" },
        { name: "Supporto WhatsApp", desc: "Assistenza rapida via WhatsApp con una persona reale.", badge: "Support" },
      ],
    },
    pricing: {
      kicker: "Prezzo",
      title: "Tutto incluso. 2 CHF al giorno.",
      sub: "Circa 60 CHF al mese. Meno di un caffè e una brioche.",
      daily: "al giorno", monthly: "al mese",
      cols: { metric: "Confronto", gwd: "GWD AI", rec: "Receptionist / centralino" },
      rows: [
        ["Costo mensile", "60 CHF · tutto incluso", "3'800–4'500 CHF"],
        ["Disponibilità", "24/7, festivi inclusi", "8h al giorno, feriale"],
        ["Chiamate simultanee", "Infinite — mai occupato", "Una alla volta"],
        ["Lingue", "IT · DE · FR · EN", "Spesso 1–2"],
        ["App + sito web", "Inclusi", "Non inclusi"],
        ["Attivazione", "48 ore", "Settimane"],
      ],
      cta: "Attiva ora su WhatsApp",
      note: "Nessun vincolo. Disdici quando vuoi.",
    },
    demo: {
      kicker: "Demo live",
      title: "Ascolta come risponde l'AI",
      sub: "Una conversazione realistica simulata: così l'agente GWD gestisce una prenotazione.",
      play: "Ascolta una chiamata demo", replay: "Riascolta",
      playing: "Chiamata in corso…", ended: "Chiamata conclusa · Prenotazione registrata",
      scenarios: { salon: "Parrucchiere", restaurant: "Ristorante" },
      confirm: "Prenotazione confermata", caller: "Cliente", ai: "GWD AI",
      scripts: {
        salon: [
          { who: "ai", text: "Salone Élite, buongiorno! Sono Sofia, l'assistente del salone. Mi dica pure, come posso aiutarla?" },
          { who: "caller", text: "Buongiorno! Volevo prenotare un taglio con colore, possibilmente questa settimana." },
          { who: "ai", text: "Certo, volentieri! Vediamo… ho libero giovedì alle 14:30, oppure sabato mattina alle 10. Cosa preferisce?" },
          { who: "caller", text: "Sabato alle 10 va benissimo." },
          { who: "ai", text: "Perfetto, allora le prenoto taglio e colore sabato alle 10 con Sara. Le arriva subito la conferma su WhatsApp. Grazie, a sabato!" },
        ],
        restaurant: [
          { who: "ai", text: "Ristorante Da Marco, buonasera! Sono Sofia, l'assistente del ristorante. Come posso aiutarla?" },
          { who: "caller", text: "Buonasera, avrei bisogno di un tavolo per quattro persone venerdì sera." },
          { who: "ai", text: "Volentieri! Allora, venerdì ho un tavolo alle 19:15 oppure alle 20:45. Quale le fa più comodo?" },
          { who: "caller", text: "Alle 20:45, grazie mille." },
          { who: "ai", text: "Prenotato! Tavolo per quattro, venerdì alle 20:45. Le arriva un messaggio di conferma. La aspettiamo, buona serata!" },
        ],
      },
      confirmText: { salon: "Sabato 10:00 · Taglio + Colore · Sara", restaurant: "Venerdì 20:45 · Tavolo per 4" },
    },
    why: {
      kicker: "Perché GWD",
      title: "Ogni chiamata persa è un cliente regalato al concorrente.",
      pillars: [
        { t: "Agenzia specializzata in AI", d: "Facciamo solo questo: comunicazione e agenti vocali AI per attività locali." },
        { t: "Sviluppo proprietario", d: "App, siti e piattaforma AI sviluppati da noi. Nessun intermediario." },
        { t: "Costi bassissimi", d: "2 CHF al giorno: l'AI vocale finalmente accessibile a ogni attività." },
        { t: "Fatto per la Svizzera", d: "Multilingua IT/DE/FR/EN, numeri svizzeri, supporto da Lugano." },
      ],
    },
    final: {
      title: "Non perdere più una prenotazione.",
      sub: "2 CHF al giorno. Attivo in 48 ore.",
      cta: "Attiva ora su WhatsApp", or: "oppure chiamaci",
      formTitle: "Lasciaci i tuoi dati", formSub: "Ti ricontattiamo entro 24 ore.",
      f: {
        name: "Nome e cognome", business: "Nome dell'attività", phone: "Telefono", email: "Email",
        type: "Tipo di attività", types: ["Parrucchiere / Salone", "Ristorante", "Altro"],
        message: "Messaggio (opzionale)", submit: "Invia richiesta", sending: "Invio in corso…",
        ok: "Richiesta inviata! Ti ricontattiamo entro 24 ore.",
        err: "Errore nell'invio. Scrivici su WhatsApp.",
        required: "Compila i campi obbligatori.",
      },
    },
    footer: {
      tag: "Agenti AI vocali per parrucchieri e ristoranti. Made in Switzerland.",
      contact: "Contatti", langs: "Lingue", legal: "Privacy",
      rights: "© 2026 GWD – Grafica Web Design. Tutti i diritti riservati.",
      privacyTitle: "Privacy",
      privacyText: "I dati inviati tramite questo sito (nome, contatti, messaggio) vengono utilizzati esclusivamente per rispondere alla tua richiesta e non vengono ceduti a terzi. Per informazioni: info@graficawebdesign.com.",
    },
    waFloat: "Parla con noi su WhatsApp",
  },

  de: {
    nav: {
      how: "So funktioniert's", salons: "Coiffeure", restaurants: "Restaurants",
      included: "Inklusive", pricing: "Preis", demo: "Demo", why: "Über uns",
      contact: "Kontakt", cta: "Auf WhatsApp schreiben",
    },
    hero: {
      badge: "KI-Telefonagentur · Schweiz",
      lines: ["Dein Telefon klingelt.", "Die KI antwortet.", "Du verdienst."],
      sub: "KI-Sprachagenten für Coiffeursalons und Restaurants. Automatische Buchungen, App & Website inklusive. 2 CHF pro Tag.",
      cta1: "KI testen", cta2: "WhatsApp schreiben", live: "KI ONLINE",
      stats: [
        { value: 12480, suffix: "+", label: "Beantwortete Anrufe" },
        { value: 8930, suffix: "+", label: "Verwaltete Buchungen" },
        { value: 1, suffix: "s", label: "Antwortzeit" },
        { value: 2, suffix: " CHF", label: "Pro Tag, alles inklusive" },
      ],
    },
    marquee: ["KEINE VERPASSTEN ANRUFE", "2 CHF PRO TAG", "KALENDER-SYNC", "ITALIANO · DEUTSCH · FRANÇAIS", "OUTBOUND GUERILLA CALLING", "APP & WEBSITE INKLUSIVE"],
    how: {
      kicker: "So funktioniert's",
      title: "Vom Klingeln zur Buchung in 60 Sekunden",
      sub: "Drei Schritte. Keine Software zu installieren. Keine Schulung.",
      steps: [
        { t: "Die KI nimmt den Anruf entgegen", d: "Antwortet beim ersten Klingeln mit natürlicher Stimme – auf Italienisch, Deutsch, Französisch oder Englisch." },
        { t: "Sie verwaltet die Buchung", d: "Schlägt freie Termine vor, beantwortet Fragen, verwaltet Änderungen und Absagen." },
        { t: "Bestätigung im Kalender", d: "Der Termin erscheint in der Agenda, der Kunde erhält eine Bestätigung per SMS oder WhatsApp." },
      ],
      phone: { incoming: "Eingehender Anruf…", ai: "GWD KI antwortet…", done: "Buchung bestätigt", cal: "Zum Kalender hinzugefügt" },
    },
    salon: {
      kicker: "Für Coiffeursalons",
      title: "Schere in der Hand. Das Telefon klingelt.",
      painLabel: "DAS PROBLEM",
      pain: "«Du schneidest Haare. Das Telefon klingelt. Du kannst nicht ran. Der Kunde bucht beim Konkurrenten.»",
      solLabel: "DIE LÖSUNG",
      solTitle: "Die KI antwortet für dich. Immer.",
      sol: "Der GWD KI-Agent antwortet beim ersten Klingeln mit freundlicher, natürlicher Stimme, schlägt freie Termine vor, bucht die Behandlung und schickt dir eine Benachrichtigung. Du schneidest einfach weiter.",
      bullets: ["Antwortet in 1 Sekunde, auch während du arbeitest", "Trägt den Termin direkt in die Agenda ein", "Keine verpassten Anrufe, keine verschenkten Kunden"],
      cta: "Für deinen Salon aktivieren",
    },
    restaurant: {
      kicker: "Für Restaurants",
      title: "Stosszeit. Niemand kann antworten.",
      painLabel: "DAS PROBLEM",
      pain: "«Voller Saal, Küche auf Anschlag. Sieben verpasste Anrufe in einer Stunde. Das sind verschenkte Tische – und Umsatz.»",
      solLabel: "DIE LÖSUNG",
      solTitle: "Die KI bucht die Tische. 24/7.",
      sol: "Die KI beantwortet mehrere Anrufe gleichzeitig, bucht Tische, verwaltet Änderungen und Absagen und beantwortet Fragen zum Menü. Auch um Mitternacht.",
      bullets: ["Verwaltet mehrere Anrufe gleichzeitig", "Buchungen, Änderungen und Absagen automatisch", "Beantwortet Fragen zu Menü und Allergenen"],
      cta: "Für dein Restaurant aktivieren",
    },
    included: {
      kicker: "Alles inklusive",
      title: "Alles. Auf einer Plattform.",
      sub: "Keine versteckten Kosten. Keine Extra-Anbieter.",
      items: [
        { name: "KI-Telefonagent (Inbound)", desc: "Beantwortet eingehende Anrufe mit natürlicher Stimme, bucht und informiert.", badge: "Core" },
        { name: "Outbound-Anrufe", desc: "Outbound-Kampagnen und Telefon-Guerilla-Marketing zur Kundenreaktivierung.", badge: "Growth" },
        { name: "Eigene App", desc: "Deine App für iOS und Android mit Buchungen und Push-Nachrichten.", badge: "iOS · Android" },
        { name: "Website inklusive", desc: "Schnelle, moderne Website, die Besucher in Buchungen verwandelt.", badge: "Web" },
        { name: "Kalender & POS", desc: "Sync mit Google Kalender und gängigen Kassensystemen.", badge: "Sync 24/7" },
        { name: "Mehrsprachig (CH)", desc: "Italienisch, Deutsch, Französisch und Englisch. Wie deine Kunden.", badge: "IT·DE·FR·EN" },
        { name: "Reports & Statistiken", desc: "Aufzeichnungen, Anrufanalysen und klare Monatsreports.", badge: "Analytics" },
        { name: "WhatsApp-Support", desc: "Schnelle Hilfe via WhatsApp von einer echten Person.", badge: "Support" },
      ],
    },
    pricing: {
      kicker: "Preis",
      title: "Alles inklusive. 2 CHF pro Tag.",
      sub: "Etwa 60 CHF pro Monat. Weniger als Kaffee und Gipfeli.",
      daily: "pro Tag", monthly: "pro Monat",
      cols: { metric: "Vergleich", gwd: "GWD KI", rec: "Rezeptionist / Telefondienst" },
      rows: [
        ["Monatliche Kosten", "60 CHF · alles inklusive", "3'800–4'500 CHF"],
        ["Verfügbarkeit", "24/7, auch Feiertage", "8h/Tag, werktags"],
        ["Gleichzeitige Anrufe", "Unbegrenzt — nie besetzt", "Einer pro Leitung"],
        ["Sprachen", "IT · DE · FR · EN", "Meist 1–2"],
        ["App + Website", "Inklusive", "Nicht inklusive"],
        ["Aktivierung", "48 Stunden", "Wochen"],
      ],
      cta: "Jetzt per WhatsApp aktivieren",
      note: "Keine Bindung. Jederzeit kündbar.",
    },
    demo: {
      kicker: "Live-Demo",
      title: "Hör zu, wie die KI antwortet",
      sub: "Ein simuliertes, realistisches Gespräch: So verwaltet der GWD-Agent eine Buchung.",
      play: "Demo-Anruf anhören", replay: "Nochmal anhören",
      playing: "Anruf läuft…", ended: "Anruf beendet · Buchung erfasst",
      scenarios: { salon: "Coiffeur", restaurant: "Restaurant" },
      confirm: "Buchung bestätigt", caller: "Kunde", ai: "GWD KI",
      scripts: {
        salon: [
          { who: "ai", text: "Salon Élite, guten Tag! Hier ist Sofia, die Assistentin des Salons. Wie kann ich Ihnen helfen?" },
          { who: "caller", text: "Guten Tag! Ich würde gern diese Woche einen Termin für Schnitt und Farbe buchen." },
          { who: "ai", text: "Sehr gern! Schauen wir… frei wäre Donnerstag um 14:30 oder Samstagvormittag um 10. Was passt Ihnen besser?" },
          { who: "caller", text: "Samstag um 10 passt perfekt." },
          { who: "ai", text: "Wunderbar, dann buche ich Schnitt und Farbe am Samstag um 10 Uhr bei Sara. Die Bestätigung kommt gleich per WhatsApp. Bis Samstag!" },
        ],
        restaurant: [
          { who: "ai", text: "Ristorante Da Marco, guten Abend! Hier ist Sofia, die Assistentin des Restaurants. Wie kann ich helfen?" },
          { who: "caller", text: "Guten Abend, ich bräuchte einen Tisch für vier Personen am Freitagabend." },
          { who: "ai", text: "Sehr gern! Am Freitag hätte ich um 19:15 oder um 20:45 etwas frei. Was passt Ihnen besser?" },
          { who: "caller", text: "Um 20:45, vielen Dank." },
          { who: "ai", text: "Reserviert! Tisch für vier, Freitag 20:45. Sie bekommen gleich eine Bestätigung per Nachricht. Wir freuen uns auf Sie!" },
        ],
      },
      confirmText: { salon: "Samstag 10:00 · Schnitt + Farbe · Sara", restaurant: "Freitag 20:45 · Tisch für 4" },
    },
    why: {
      kicker: "Warum GWD",
      title: "Jeder verpasste Anruf ist ein Kunde, den du der Konkurrenz schenkst.",
      pillars: [
        { t: "Auf KI spezialisiert", d: "Wir machen nur das: Kommunikation und KI-Sprachagenten für lokale Betriebe." },
        { t: "Eigene Entwicklung", d: "App, Website und KI-Plattform von uns entwickelt. Keine Zwischenhändler." },
        { t: "Tiefe Kosten", d: "2 CHF pro Tag: KI-Telefonie endlich für jeden Betrieb erschwinglich." },
        { t: "Für die Schweiz gebaut", d: "Mehrsprachig IT/DE/FR/EN, Schweizer Nummern, Support aus Lugano." },
      ],
    },
    final: {
      title: "Verpasse keine Buchung mehr.",
      sub: "2 CHF pro Tag. Aktiv in 48 Stunden.",
      cta: "Jetzt per WhatsApp aktivieren", or: "oder ruf uns an",
      formTitle: "Hinterlass uns deine Daten", formSub: "Wir melden uns innerhalb von 24 Stunden.",
      f: {
        name: "Vor- und Nachname", business: "Name des Betriebs", phone: "Telefon", email: "E-Mail",
        type: "Art des Betriebs", types: ["Coiffeur / Salon", "Restaurant", "Andere"],
        message: "Nachricht (optional)", submit: "Anfrage senden", sending: "Wird gesendet…",
        ok: "Anfrage gesendet! Wir melden uns innert 24 Stunden.",
        err: "Fehler beim Senden. Schreib uns auf WhatsApp.",
        required: "Bitte Pflichtfelder ausfüllen.",
      },
    },
    footer: {
      tag: "KI-Sprachagenten für Coiffeure und Restaurants. Made in Switzerland.",
      contact: "Kontakt", langs: "Sprachen", legal: "Datenschutz",
      rights: "© 2026 GWD – Grafica Web Design. Alle Rechte vorbehalten.",
      privacyTitle: "Datenschutz",
      privacyText: "Die über diese Website übermittelten Daten (Name, Kontakte, Nachricht) werden ausschliesslich zur Beantwortung deiner Anfrage verwendet und nicht an Dritte weitergegeben. Infos: info@graficawebdesign.com.",
    },
    waFloat: "Schreib uns auf WhatsApp",
  },

  fr: {
    nav: {
      how: "Comment ça marche", salons: "Coiffeurs", restaurants: "Restaurants",
      included: "Inclus", pricing: "Prix", demo: "Démo", why: "Qui sommes-nous",
      contact: "Contact", cta: "Écrire sur WhatsApp",
    },
    hero: {
      badge: "Agence vocale IA · Suisse",
      lines: ["Ton téléphone sonne.", "L'IA répond.", "Tu gagnes."],
      sub: "Agents vocaux IA pour salons de coiffure et restaurants. Réservations automatiques, app et site inclus. 2 CHF par jour.",
      cta1: "Tester l'IA", cta2: "Écrire sur WhatsApp", live: "IA EN LIGNE",
      stats: [
        { value: 12480, suffix: "+", label: "Appels répondus" },
        { value: 8930, suffix: "+", label: "Réservations gérées" },
        { value: 1, suffix: "s", label: "Temps de réponse" },
        { value: 2, suffix: " CHF", label: "Par jour, tout inclus" },
      ],
    },
    marquee: ["ZÉRO APPEL MANQUÉ", "2 CHF PAR JOUR", "AGENDA SYNCHRONISÉ", "ITALIANO · DEUTSCH · FRANÇAIS", "APPELS SORTANTS GUERRILLA", "APP & SITE INCLUS"],
    how: {
      kicker: "Comment ça marche",
      title: "De la sonnerie à la réservation en 60 secondes",
      sub: "Trois étapes. Aucun logiciel à installer. Aucune formation.",
      steps: [
        { t: "L'IA prend l'appel", d: "Elle répond à la première sonnerie avec une voix naturelle, en italien, allemand, français ou anglais." },
        { t: "Elle gère la réservation", d: "Propose les créneaux libres, répond aux questions, gère modifications et annulations." },
        { t: "Confirmation à l'agenda", d: "Le rendez-vous apparaît dans l'agenda et le client reçoit une confirmation par SMS ou WhatsApp." },
      ],
      phone: { incoming: "Appel entrant…", ai: "GWD IA répond…", done: "Réservation confirmée", cal: "Ajouté au calendrier" },
    },
    salon: {
      kicker: "Pour les coiffeurs",
      title: "Les ciseaux à la main. Le téléphone sonne.",
      painLabel: "LE PROBLÈME",
      pain: "«Tu coupes les cheveux. Le téléphone sonne. Tu ne peux pas répondre. Le client réserve chez le concurrent.»",
      solLabel: "LA SOLUTION",
      solTitle: "L'IA répond pour toi. Toujours.",
      sol: "L'agent IA GWD répond à la première sonnerie avec une voix chaleureuse et naturelle, propose les créneaux libres, réserve le soin et t'envoie une notification. Toi, tu continues à coiffer.",
      bullets: ["Répond en 1 seconde, même pendant que tu travailles", "Inscrit le rendez-vous directement dans l'agenda", "Zéro appel manqué, zéro client offert"],
      cta: "Activer pour ton salon",
    },
    restaurant: {
      kicker: "Pour les restaurants",
      title: "Heure de pointe. Personne ne peut répondre.",
      painLabel: "LE PROBLÈME",
      pain: "«Salle comble, cuisine à fond. Sept appels manqués en une heure. Ce sont des tables — et du chiffre — offerts.»",
      solLabel: "LA SOLUTION",
      solTitle: "L'IA réserve les tables. 24/7.",
      sol: "L'IA répond à plusieurs appels en même temps, réserve les tables, gère modifications et annulations et répond aux questions sur le menu. Même à minuit.",
      bullets: ["Gère plusieurs appels simultanément", "Réservations, modifications et annulations automatiques", "Répond aux questions sur le menu et les allergènes"],
      cta: "Activer pour ton restaurant",
    },
    included: {
      kicker: "Tout est inclus",
      title: "Tout. Sur une seule plateforme.",
      sub: "Aucun coût caché. Aucun fournisseur en plus.",
      items: [
        { name: "Agent IA téléphonique", desc: "Répond aux appels entrants avec une voix naturelle, réserve et informe.", badge: "Core" },
        { name: "Appels sortants", desc: "Campagnes outbound et guérilla marketing téléphonique pour réactiver les clients.", badge: "Growth" },
        { name: "App personnalisée", desc: "Ton app iOS et Android avec réservations et notifications.", badge: "iOS · Android" },
        { name: "Site web inclus", desc: "Site rapide et moderne qui transforme les visiteurs en réservations.", badge: "Web" },
        { name: "Agenda & caisse", desc: "Synchronisation avec Google Agenda et les principaux logiciels.", badge: "Sync 24/7" },
        { name: "Multilingue suisse", desc: "Italien, allemand, français et anglais. Comme tes clients.", badge: "IT·DE·FR·EN" },
        { name: "Rapports & stats", desc: "Enregistrements, analyses d'appels et rapports mensuels clairs.", badge: "Analytics" },
        { name: "Support WhatsApp", desc: "Aide rapide via WhatsApp avec une vraie personne.", badge: "Support" },
      ],
    },
    pricing: {
      kicker: "Prix",
      title: "Tout inclus. 2 CHF par jour.",
      sub: "Environ 60 CHF par mois. Moins qu'un café-croissant.",
      daily: "par jour", monthly: "par mois",
      cols: { metric: "Comparaison", gwd: "GWD IA", rec: "Réceptionniste / standard" },
      rows: [
        ["Coût mensuel", "60 CHF · tout inclus", "3'800–4'500 CHF"],
        ["Disponibilité", "24/7, jours fériés inclus", "8h/jour, semaine"],
        ["Appels simultanés", "Illimités — jamais occupé", "Un à la fois"],
        ["Langues", "IT · DE · FR · EN", "Souvent 1–2"],
        ["App + site web", "Inclus", "Non inclus"],
        ["Activation", "48 heures", "Des semaines"],
      ],
      cta: "Activer sur WhatsApp",
      note: "Sans engagement. Résiliable à tout moment.",
    },
    demo: {
      kicker: "Démo live",
      title: "Écoute comment l'IA répond",
      sub: "Une conversation réaliste simulée : ainsi l'agent GWD gère une réservation.",
      play: "Écouter un appel démo", replay: "Réécouter",
      playing: "Appel en cours…", ended: "Appel terminé · Réservation enregistrée",
      scenarios: { salon: "Coiffeur", restaurant: "Restaurant" },
      confirm: "Réservation confirmée", caller: "Client", ai: "GWD IA",
      scripts: {
        salon: [
          { who: "ai", text: "Salon Élite, bonjour ! Ici Sofia, l'assistante du salon. Comment puis-je vous aider ?" },
          { who: "caller", text: "Bonjour ! Je voudrais réserver une coupe avec couleur, si possible cette semaine." },
          { who: "ai", text: "Avec grand plaisir ! Voyons… j'ai jeudi à 14h30, ou samedi matin à 10h. Qu'est-ce qui vous arrange ?" },
          { who: "caller", text: "Samedi à 10h, c'est parfait." },
          { who: "ai", text: "Parfait, je vous réserve coupe et couleur samedi à 10h avec Sara. Vous recevez tout de suite la confirmation sur WhatsApp. À samedi !" },
        ],
        restaurant: [
          { who: "ai", text: "Ristorante Da Marco, bonsoir ! Ici Sofia, l'assistante du restaurant. Comment puis-je vous aider ?" },
          { who: "caller", text: "Bonsoir, j'aurais besoin d'une table pour quatre personnes vendredi soir." },
          { who: "ai", text: "Volontiers ! Alors, vendredi j'ai une table à 19h15 ou à 20h45. Laquelle vous convient le mieux ?" },
          { who: "caller", text: "À 20h45, merci beaucoup." },
          { who: "ai", text: "C'est réservé ! Table pour quatre, vendredi 20h45. Vous recevrez un message de confirmation. Au plaisir de vous accueillir !" },
        ],
      },
      confirmText: { salon: "Samedi 10h00 · Coupe + Couleur · Sara", restaurant: "Vendredi 20h45 · Table pour 4" },
    },
    why: {
      kicker: "Pourquoi GWD",
      title: "Chaque appel manqué est un client offert au concurrent.",
      pillars: [
        { t: "Agence spécialisée IA", d: "On ne fait que ça : communication et agents vocaux IA pour commerces locaux." },
        { t: "Développement maison", d: "App, site et plateforme IA développés par nous. Sans intermédiaires." },
        { t: "Coûts minimes", d: "2 CHF par jour : la voix IA enfin accessible à chaque commerce." },
        { t: "Pensé pour la Suisse", d: "Multilingue IT/DE/FR/EN, numéros suisses, support depuis Lugano." },
      ],
    },
    final: {
      title: "Ne perds plus une réservation.",
      sub: "2 CHF par jour. Actif en 48 heures.",
      cta: "Activer sur WhatsApp", or: "ou appelle-nous",
      formTitle: "Laisse-nous tes coordonnées", formSub: "On te rappelle sous 24 heures.",
      f: {
        name: "Nom et prénom", business: "Nom de l'activité", phone: "Téléphone", email: "E-mail",
        type: "Type d'activité", types: ["Coiffeur / Salon", "Restaurant", "Autre"],
        message: "Message (optionnel)", submit: "Envoyer la demande", sending: "Envoi en cours…",
        ok: "Demande envoyée ! On te rappelle sous 24 h.",
        err: "Erreur d'envoi. Écris-nous sur WhatsApp.",
        required: "Remplis les champs obligatoires.",
      },
    },
    footer: {
      tag: "Agents vocaux IA pour coiffeurs et restaurants. Made in Switzerland.",
      contact: "Contact", langs: "Langues", legal: "Confidentialité",
      rights: "© 2026 GWD – Grafica Web Design. Tous droits réservés.",
      privacyTitle: "Confidentialité",
      privacyText: "Les données envoyées via ce site (nom, coordonnées, message) sont utilisées uniquement pour répondre à ta demande et ne sont pas transmises à des tiers. Infos : info@graficawebdesign.com.",
    },
    waFloat: "Parle avec nous sur WhatsApp",
  },

  en: {
    nav: {
      how: "How it works", salons: "Hair salons", restaurants: "Restaurants",
      included: "What's included", pricing: "Pricing", demo: "Demo", why: "Why us",
      contact: "Contact", cta: "Chat on WhatsApp",
    },
    hero: {
      badge: "AI voice agency · Switzerland",
      lines: ["Your phone rings.", "AI answers.", "You earn."],
      sub: "AI voice agents for hair salons and restaurants. Automatic bookings, app & website included. 2 CHF a day.",
      cta1: "Try the AI", cta2: "Message us on WhatsApp", live: "AI ONLINE",
      stats: [
        { value: 12480, suffix: "+", label: "Calls answered" },
        { value: 8930, suffix: "+", label: "Bookings handled" },
        { value: 1, suffix: "s", label: "Response time" },
        { value: 2, suffix: " CHF", label: "Per day, all inclusive" },
      ],
    },
    marquee: ["ZERO MISSED CALLS", "2 CHF A DAY", "CALENDAR SYNCED", "ITALIANO · DEUTSCH · FRANÇAIS", "OUTBOUND GUERRILLA CALLING", "APP & WEBSITE INCLUDED"],
    how: {
      kicker: "How it works",
      title: "From ring to booking in 60 seconds",
      sub: "Three steps. No software to install. No training.",
      steps: [
        { t: "The AI takes the call", d: "Answers on the first ring with a natural voice, in Italian, German, French or English." },
        { t: "It handles the booking", d: "Offers free slots, answers questions, manages changes and cancellations." },
        { t: "Confirmed to your calendar", d: "The appointment appears in your calendar and the client gets an SMS or WhatsApp confirmation." },
      ],
      phone: { incoming: "Incoming call…", ai: "GWD AI answering…", done: "Booking confirmed", cal: "Added to calendar" },
    },
    salon: {
      kicker: "For hair salons",
      title: "Scissors in hand. The phone rings.",
      painLabel: "THE PROBLEM",
      pain: "“You're cutting hair. The phone rings. You can't answer. The client books with your competitor.”",
      solLabel: "THE SOLUTION",
      solTitle: "AI answers for you. Always.",
      sol: "The GWD AI agent answers on the first ring with a warm, natural voice, offers free slots, books the treatment and sends you a notification. You keep cutting.",
      bullets: ["Answers in 1 second, even while you work", "Writes the appointment straight into your calendar", "Zero missed calls, zero gifted clients"],
      cta: "Activate for your salon",
    },
    restaurant: {
      kicker: "For restaurants",
      title: "Rush hour. Nobody can answer.",
      painLabel: "THE PROBLEM",
      pain: "“Full house, kitchen on fire. Seven missed calls in an hour. That's tables — and revenue — given away.”",
      solLabel: "THE SOLUTION",
      solTitle: "AI books the tables. 24/7.",
      sol: "The AI answers several calls at once, books tables, handles changes and cancellations and answers menu questions. Even at midnight.",
      bullets: ["Handles multiple calls at once", "Bookings, changes and cancellations on autopilot", "Answers menu and allergen questions"],
      cta: "Activate for your restaurant",
    },
    included: {
      kicker: "What's included",
      title: "Everything. One platform.",
      sub: "No hidden costs. No extra vendors.",
      items: [
        { name: "AI phone agent (inbound)", desc: "Answers incoming calls with a natural voice, books and informs.", badge: "Core" },
        { name: "Outbound calling", desc: "Outbound campaigns and phone guerrilla marketing to win back clients.", badge: "Growth" },
        { name: "Custom app", desc: "Your own iOS & Android app with bookings and notifications.", badge: "iOS · Android" },
        { name: "Website included", desc: "Fast, modern website built to turn visitors into bookings.", badge: "Web" },
        { name: "Calendar & POS", desc: "Syncs with Google Calendar and leading POS systems.", badge: "Sync 24/7" },
        { name: "Swiss multilingual", desc: "Italian, German, French and English. Like your customers.", badge: "IT·DE·FR·EN" },
        { name: "Reports & analytics", desc: "Call recordings, analytics and clear monthly reports.", badge: "Analytics" },
        { name: "WhatsApp support", desc: "Fast help on WhatsApp from a real human.", badge: "Support" },
      ],
    },
    pricing: {
      kicker: "Pricing",
      title: "All inclusive. 2 CHF a day.",
      sub: "About 60 CHF a month. Less than a coffee and a croissant.",
      daily: "per day", monthly: "per month",
      cols: { metric: "Comparison", gwd: "GWD AI", rec: "Receptionist / answering service" },
      rows: [
        ["Monthly cost", "60 CHF · all inclusive", "CHF 3'800–4'500"],
        ["Availability", "24/7, holidays included", "8h/day, weekdays"],
        ["Simultaneous calls", "Unlimited — never busy", "One at a time"],
        ["Languages", "IT · DE · FR · EN", "Often 1–2"],
        ["App + website", "Included", "Not included"],
        ["Setup", "48 hours", "Weeks"],
      ],
      cta: "Activate now on WhatsApp",
      note: "No lock-in. Cancel anytime.",
    },
    demo: {
      kicker: "Live demo",
      title: "Hear how the AI answers",
      sub: "A realistic simulated conversation: this is how the GWD agent handles a booking.",
      play: "Play a demo call", replay: "Play again",
      playing: "Call in progress…", ended: "Call ended · Booking recorded",
      scenarios: { salon: "Hair salon", restaurant: "Restaurant" },
      confirm: "Booking confirmed", caller: "Customer", ai: "GWD AI",
      scripts: {
        salon: [
          { who: "ai", text: "Salon Élite, good morning! This is Sofia, the salon's assistant. How can I help you?" },
          { who: "caller", text: "Good morning! I'd like to book a cut and colour, ideally this week." },
          { who: "ai", text: "Of course, happy to! Let's see… I have Thursday at 2:30 pm, or Saturday morning at 10. Which suits you best?" },
          { who: "caller", text: "Saturday at 10 is perfect." },
          { who: "ai", text: "Perfect, then I'll book you a cut and colour on Saturday at 10 with Sara. You'll get the confirmation on WhatsApp right away. See you Saturday!" },
        ],
        restaurant: [
          { who: "ai", text: "Ristorante Da Marco, good evening! This is Sofia, the restaurant's assistant. How can I help you?" },
          { who: "caller", text: "Good evening, I'd need a table for four on Friday evening." },
          { who: "ai", text: "Happy to! So, on Friday I have a table at 7:15 pm or at 8:45 pm. Which one works better for you?" },
          { who: "caller", text: "8:45, thank you very much." },
          { who: "ai", text: "Booked! Table for four, Friday 8:45 pm. You'll receive a confirmation message. We look forward to seeing you!" },
        ],
      },
      confirmText: { salon: "Saturday 10:00 · Cut + Colour · Sara", restaurant: "Friday 8:45 pm · Table for 4" },
    },
    why: {
      kicker: "Why GWD",
      title: "Every missed call is a client gifted to your competitor.",
      pillars: [
        { t: "AI-specialised agency", d: "We do one thing: communication and AI voice agents for local businesses." },
        { t: "In-house development", d: "App, website and AI platform built by us. No middlemen." },
        { t: "Ultra-low cost", d: "2 CHF a day: voice AI finally affordable for every business." },
        { t: "Built for Switzerland", d: "Multilingual IT/DE/FR/EN, Swiss numbers, support from Lugano." },
      ],
    },
    final: {
      title: "Never miss a booking again.",
      sub: "2 CHF a day. Live in 48 hours.",
      cta: "Activate now on WhatsApp", or: "or call us",
      formTitle: "Leave your details", formSub: "We'll get back to you within 24 hours.",
      f: {
        name: "Full name", business: "Business name", phone: "Phone", email: "Email",
        type: "Business type", types: ["Hair salon", "Restaurant", "Other"],
        message: "Message (optional)", submit: "Send request", sending: "Sending…",
        ok: "Request sent! We'll reply within 24 hours.",
        err: "Send failed. Message us on WhatsApp.",
        required: "Please fill the required fields.",
      },
    },
    footer: {
      tag: "AI voice agents for hair salons and restaurants. Made in Switzerland.",
      contact: "Contact", langs: "Languages", legal: "Privacy",
      rights: "© 2026 GWD – Grafica Web Design. All rights reserved.",
      privacyTitle: "Privacy",
      privacyText: "Data submitted through this site (name, contact details, message) is used solely to respond to your enquiry and is never shared with third parties. Info: info@graficawebdesign.com.",
    },
    waFloat: "Chat with us on WhatsApp",
  },
};
